import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { components } from 'react-select';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';

import SelectInput from '../input/SelectInput';

import '../../sass/components/common/DashboardFilters.scss';

const INTERVALS = [
  { id: 'daily', name: 'Daily' },
  { id: 'weekly', name: 'Weekly' },
  { id: 'monthly', name: 'Monthly' },
  { id: 'quarterly', name: 'Quarterly' },
  { id: 'yearly', name: 'Yearly' },
];

const PERIODS = [
  { id: 'today', name: 'Today' },
  { id: 'yesterday', name: 'Yesterday' },
  { id: 'last_7', name: 'Last 7 days' },
  { id: 'last_30', name: 'Last 30 days' },
  { id: 'this_month', name: 'This month' },
  { id: 'last_month', name: 'Last month' },
  { id: 'custom', name: 'Custom range' },
];

const getDateIntervalFromInterval = (interval) => {
  let from = moment();
  let to = moment();
  if (interval === 'weekly') {
    from = moment().startOf('week').add(1, 'd');
    to = moment().endOf('week').add(1, 'd');
  } else if (interval === 'monthly') {
    from = moment().startOf('month');
    to = moment().endOf('month');
  } else if (interval === 'quarterly') {
    from = moment().startOf('quarter');
    to = moment().endOf('quarter');
  } else if (interval === 'yearly') {
    from = moment().startOf('year');
    to = moment().endOf('year');
  }
  return ({ from, to })
}

const getDateIntervalFromPeriod = (period) => {
  let from = moment();
  let to = moment();
  if (period === 'yesterday') {
    from = moment().subtract(1, 'd');
    to = moment().subtract(1, 'd');
  } else if (period === 'last_7') {
    from = moment().subtract(7, 'd');
  } else if (period === 'last_30') {
    from = moment().subtract(30, 'd');
  } else if (period === 'this_month') {
    from = moment().startOf('month');
    to = moment().endOf('month');
  } else if (period === 'last_month') {
    from = moment().subtract(1, 'M').startOf('month');
    to = moment().subtract(1, 'M').endOf('month');
  }
  return ({ from, to })
}

const mapStoreToProps = (store) => {
  return {
    isMobile: store.setup.isMobile,
  }
};

class DashboardFilters extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showDatePicker: false,
      datePickerFrom: null,
      datePickerTo: null,
      datePickerOption: null,
      dateTextFrom: '',
      dateTextTo: '',
    };
  }

  componentDidMount = () => {
    const value = this.props.value || {};
    if (value.from && value.to) {
      this.props.onChange({
        from: value.from,
        to: value.to,
      });
    } else {
      const { from, to } = getDateIntervalFromInterval('weekly');
      this.props.onChange({
        from: from.format('YYYY-MM-DD'),
        to: to.format('YYYY-MM-DD'),
      });
    }
  }

  showDatePiker = () => {
    const value = this.props.value || {};
    this.setState({
      datePickerFrom: new Date(value.from),
      datePickerTo: new Date(value.to),
      datePickerOption: value.period,
      showDatePicker: true,
      dateTextFrom: moment(value.from).format('DD/MM/YYYY'),
      dateTextTo: moment(value.to).format('DD/MM/YYYY'),
    });
  }

  selectDatepickerOption = (period) => {
    const { from, to } = getDateIntervalFromPeriod(period);
    this.setState({
      dateTextFrom: from.format('DD/MM/YYYY'),
      dateTextTo: to.format('DD/MM/YYYY'),
      datePickerOption: period,
      datePickerFrom: from.toDate(),
      datePickerTo: to.toDate(),
    });
  }

  applyDatePicker = () => {
    this.props.onChange({
      period: this.state.datePickerOption,
      from: moment(this.state.datePickerFrom).format('YYYY-MM-DD'),
      to: moment(this.state.datePickerTo).format('YYYY-MM-DD'),
    });
    this.setState({showDatePicker: false});
  }

  onTextDateChange = (key, value) => {
    const date = moment(value, 'DD/MM/YYYY');
    if (date.isValid() && value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      this.setState({
        [key === 'from' ? 'dateTextFrom' : 'dateTextTo']: value,
        [key === 'from' ? 'datePickerFrom' : 'datePickerTo']: date.toDate(),
        datePickerOption: 'custom',
      });
    } else {
      this.setState({
        [key === 'from' ? 'dateTextFrom' : 'dateTextTo']: value
      });
    }
  }

  renderDatePicker = () => {
    if (!this.state.showDatePicker) {
      return null;
    }
    const renderDay = (day, date) => {
      return <span>{day}</span>;
    };
    return (
      <div
        className='datePickerOverlay'
        onClick={e => {
          if (e.target === e.currentTarget) {
            this.setState({showDatePicker: false});
          }
        }}
      >
        <div className='datePickerContainer'>
          <div className='datePickerContent'>
            <div className='datePickerOptions'>
              {PERIODS.map(i =>
                <div
                  key={i.id}
                  className={classnames('periodOption', {
                    'selected': this.state.datePickerOption === i.id,
                  })}
                  onClick={() => this.selectDatepickerOption(i.id)}
                >{i.name}</div>
              )}
            </div>
            <div className='datePickerDates'>
              <div className='dateTextInputs'>
              InputMask
                <InputMask
                  mask='99/99/9999'
                  value={this.state.dateTextFrom}
                  onChange={e => this.onTextDateChange('from', e.target.value)}
                  placeholder='dd/mm/yyyy'
                />
                <span/>
                <InputMask
                  mask='99/99/9999'
                  value={this.state.dateTextTo}
                  onChange={e => this.onTextDateChange('to', e.target.value)}
                  placeholder='dd/mm/yyyy'
                />
              </div>
              <DatePicker
                calendarStartDay={1}
                renderDayContents={renderDay}
                selected={this.state.datePickerFrom}
                onChange={([start, end]) => {
                  this.setState({
                    dateTextFrom: moment(start).format('DD/MM/YYYY'),
                    dateTextTo: moment(end).format('DD/MM/YYYY'),
                    datePickerFrom: start,
                    datePickerTo: end,
                    datePickerOption: 'custom',
                  });
                }}
                startDate={this.state.datePickerFrom}
                endDate={this.state.datePickerTo}
                dateFormatCalendar='LLL yyyy'
                formatWeekDay={day => day.substr(0, 3)}
                selectsRange
                inline
              />
            </div>
          </div>
          <div className='datePickerButtons'>
            <button onClick={this.applyDatePicker}>Apply</button>
          </div>
        </div>
      </div>
    )
  }

  renderMobileMenu = ({ options, selectOption, selectProps, ...props }) => {
    return (
      <div
        className='mobileMenu'
        onClick={e => {
          if (e.target === e.currentTarget) {
            selectProps.onMenuClose(e);
          }
        }}
      >
        <div className='mobileMenuContent'>
          {selectProps.title ?
            <div className='menuHeader'>
              <div
                className='closeButton'
                onClick={selectProps.onMenuClose}
              >
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d='M13.2997 0.710001C12.9097 0.320001 12.2797 0.320001 11.8897 0.710001L6.99973 5.59L2.10973 0.700001C1.71973 0.310001 1.08973 0.310001 0.699727 0.700001C0.309727 1.09 0.309727 1.72 0.699727 2.11L5.58973 7L0.699727 11.89C0.309727 12.28 0.309727 12.91 0.699727 13.3C1.08973 13.69 1.71973 13.69 2.10973 13.3L6.99973 8.41L11.8897 13.3C12.2797 13.69 12.9097 13.69 13.2997 13.3C13.6897 12.91 13.6897 12.28 13.2997 11.89L8.40973 7L13.2997 2.11C13.6797 1.73 13.6797 1.09 13.2997 0.710001Z'/>
                </svg>
              </div>
              {selectProps.title}
            </div>
          : null}
          <div className='menuList'>
            {options.map(i =>
              <div
                key={i.value}
                className='listItem'
                onClick={() => selectOption(i)}
              >
                {i.label}
                {selectProps.value.value === i.value ?
                  <svg width='18' height='13' viewBox='0 0 18 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M6.00012 10.2L2.50012 6.70001C2.11012 6.31001 1.49012 6.31001 1.10012 6.70001C0.710117 7.09001 0.710117 7.71001 1.10012 8.10001L5.29012 12.29C5.68012 12.68 6.31012 12.68 6.70012 12.29L17.3001 1.70001C17.6901 1.31001 17.6901 0.690007 17.3001 0.300007C16.9101 -0.0899927 16.2901 -0.0899927 15.9001 0.300007L6.00012 10.2Z'/>
                  </svg>
                : null}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderPeriodValue = ({ children, ...props }) => {
    let displayValue = '';
    let fromStr = '';
    let toStr = '';
    const value = props.data.value;
    if (this.state.showDatePicker) {
      const from = this.state.datePickerFrom;
      const to = this.state.datePickerTo;
      fromStr = from ? moment(from).format('DD MMM, YYYY') : '...';
      toStr = to ? moment(to).format('DD MMM, YYYY') : '...';
    } else if (value === 'custom') {
      const { from, to } = this.props.value || {};
      fromStr = moment(from).format('DD MMM, YYYY');
      toStr = moment(to).format('DD MMM, YYYY');
    } else {
      const { from, to } = getDateIntervalFromPeriod(value);
      fromStr = from.format('DD MMM, YYYY');
      toStr = to.format('DD MMM, YYYY');
    }
    if (fromStr === toStr) {
      displayValue = fromStr;
    } else {
      displayValue = `${fromStr} - ${toStr}`;
    }
    return (
      <components.SingleValue {...props}>{displayValue}</components.SingleValue>
    );
  };

  render = () => {
    const value = this.props.value || {};
    return (
      <div className='dashboardFilters'>
        <div className='selectsBlock'>
          {this.props.withInterval ?
            <div className='intervalSelect'>
              <SelectInput
                properties={{
                  type: 'select',
                  options: INTERVALS,
                }}
                small
                components={{
                  ...this.props.isMobile ? {
                    MenuList: this.renderMobileMenu,
                  } : {},
                }}
                selectProps={{
                  title: 'Time interval',
                }}
                isSearchable={false}
                object={value.interval}
                onChange={(k, val) => {
                  if (val === 'dayly') {
                    this.props.onChange({interval: val})
                  } else {
                    const { from, to } = getDateIntervalFromInterval(val);
                    this.props.onChange({
                      interval: val,
                      period: 'custom',
                      from: from.format('YYYY-MM-DD'),
                      to: to.format('YYYY-MM-DD'),
                    });
                  }
                }}
                onOpen={() => this.props.onOpen && this.props.onOpen('interval')}
              />
            </div>
          : null}
          <div className='periodSelect'>
            <SelectInput
              properties={{
                type: 'select',
                options: PERIODS,
              }}
              small
              components={{
                SingleValue: this.renderPeriodValue,
                ...this.props.isMobile ? {
                  MenuList: this.renderMobileMenu
                } : {},
              }}
              selectProps={{
                title: 'Date range',
              }}
              isSearchable={false}
              object={value.period}
              onChange={(k, val) => {
                if (val === 'custom') {
                  this.showDatePiker();
                  return;
                }
                const { from, to } = getDateIntervalFromPeriod(val);
                this.props.onChange({
                  period: val,
                  from: from.format('YYYY-MM-DD'),
                  to: to.format('YYYY-MM-DD'),
                });
              }}
              onOpen={() => this.props.onOpen && this.props.onOpen('period')}
            />
            {this.renderDatePicker()}
          </div>
        </div>
        <div className='downloadButtonsContaner'>
          {this.props.onDownloadRedemption ?
            <div
              className='downloadButton'
              onClick={this.props.onDownloadRedemption}
            >Download redemption report</div>
          : null}
          {this.props.onDownloadCsv ?
            <div
              className='downloadButton'
              onClick={this.props.onDownloadCsv}
            >Download CSV</div>
          : null}
        </div>
      </div>
    )
  }

}

export default connect(mapStoreToProps)(DashboardFilters);
